import { Components } from "@thisgorilla/primate-ds";
import styled from "styled-components";
import CropImageModalProps from "./CropImageModal";
import { FlexRowEnd } from "../../../../Common/Styles";

const ModalFooter = ({
  submitButtonClick,
  onCancelOrChangeImage,
  isCroppedView,
}: CropImageModalProps.ModalFooter) => {
  return (
    <Container>
      <Components.Button
        color="Neutral"
        disabled={false}
        kind="Primary"
        label={isCroppedView ? "Change Image" : "Cancel"}
        onClick={onCancelOrChangeImage}
        size="Medium"
      />
      <Components.Button
        color="Primary"
        disabled={false}
        kind="Primary"
        label={isCroppedView ? "Confirm" : "Save"}
        onClick={submitButtonClick}
        size="Medium"
      />
    </Container>
  );
};

export default ModalFooter;

const Container = styled(FlexRowEnd)`
  padding: ${({ theme }) => theme.spacing["spacing-3"].value}rem
    ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
